// Copyright (c) Docugami, Inc. All rights reserved.**/

import { SanitizingHtmlViewer } from "./SanitizingHtmlViewer";
import styled from "styled-components";

export const RichTextSanitizingHtmlViewer = styled(SanitizingHtmlViewer)`
    table {
        text-align: center;
        border-collapse: collapse;
        td {
            border: 1px solid black;
        }
        td, th {
            min-width: 150px;
        }
    }
    h1, h2, h3, h4, h5, h6 {
        font-size: 1em;
        margin: 0;
    }
`;
